// import { setEventsInSessionStorage } from 'mini-calendar-events-session-storage';

/**
 * Function to perform actions on unload callback from the browser. We are storing the mails/conversations here
 */
export const onUnloadMailWindow = async () => {
    // Keep conversations/items from view-store in sessionStorage so that page refresh or module switch can be faster
    // calendarEventsToBeCached && setEventsInSessionStorage(calendarEventsToBeCached);
    // tslint:disable-next-line: no-console
    console.log('onUnload callback called');
};
